(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vi-approved-home"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.va-routine').forEach((navigation) => {
 navigation.addEventListener('click', (event) => {
  const link = event.target.closest('a');
  if (!link || !navigation.contains(link)) return;
  navigation.querySelectorAll('a').forEach((item) => item.classList.toggle('is-selected', item === link));
 });
});

  } catch(e) { console.error(e); }
})();
})();
